import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import * as invitesReducer from './invitesReducer';
import * as commentsReducer from './commentsReducer';
import * as translationsReducer from './translationsReducer';
import * as autoCompleteReducer from './autoCompleteReducer';
import * as cropperReducer from './cropperReducer';
import * as videoUploadReducer from './videoUploadReducer';
import spinnerDisplay from './spinnerDisplayReducer';
import error from './errorReducer';
import bannedWordError from './bannedWordErrorReducer';
import modalOnDisplay from './modalOnDisplayReducer';
import basePath from './basePathReducer';
import accessToken from './accessTokenReducer';
// import gaAccount from './gaAccountReducer';
import sentryDsn from './sentryReducer';

const reducers = {
  invites: invitesReducer.invites,
  alertStatus: invitesReducer.alertStatus,
  inputAreaHeight: invitesReducer.inputAreaHeight,
  duplicateEmails: invitesReducer.duplicateEmails,
  restrictedEmails: invitesReducer.restrictedEmails,
  invitesInfoReceived: invitesReducer.invitesInfoReceived,
  comment: commentsReducer.comment,
  tempComment: commentsReducer.tempComment,
  previewToggle: commentsReducer.previewToggle,
  imageLoading: commentsReducer.imageLoading,
  uploadedImages: commentsReducer.uploadedImages,
  displayFinalMessage: commentsReducer.displayFinalMessage,
  commentsInfoReceived: commentsReducer.commentsInfoReceived,
  userSearchResults: autoCompleteReducer.userSearchResults,
  userSearchResultsHeight: autoCompleteReducer.userSearchResultsHeight,
  userSearchStatus: autoCompleteReducer.userSearchStatus,
  userSearchInView: autoCompleteReducer.userSearchInView,
  selectedUsers: autoCompleteReducer.selectedUsers,
  hoverSelectedUserIndex: autoCompleteReducer.hoverSelectedUserIndex,
  autoCompleteTextAreaValue: autoCompleteReducer.autoCompleteTextAreaValue,
  translations: translationsReducer.translations,
  privacyPolicyLink: translationsReducer.privacyPolicyLink,
  locale: translationsReducer.locale,
  scaleFactor: cropperReducer.scaleFactor,
  videoUpload: videoUploadReducer.videoUpload,
  videoFileName: videoUploadReducer.videoFileName,
  videoUploadSuccessful: videoUploadReducer.videoUploadSuccessful,
  routing: routerReducer,
  spinnerDisplay,
  error,
  bannedWordError,
  modalOnDisplay,
  basePath,
  accessToken,
  // gaAccount,
  sentryDsn,
};

export default combineReducers(reducers);
